// External libraries
import { Component } from 'react';

// Internal modules
import { fallback, isDev, logDevErrorToConsole } from '@/lib';

class ErrorBoundary extends Component {
  state = {
    error: null,
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    return {
      error,
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    if (isDev) {
      return logDevErrorToConsole(error);
    }

    fallback({
      additionalParams: {
        error,
        stackTrace: info.componentStack,
      },
      reason: 'weasley_unhandled_ui_error',
    });
  }

  render() {
    return this.props.children;
  }
}

export { ErrorBoundary };
